import PurchaseOrdersDetailsTable from '../components/PurchaseOrderDetailsTable';
import { Box, useTheme } from '@mui/material';
import PurchaseOrdersDetailsFilters from '../components/PurchaseOrderDetailsFilters';
import { useContext } from 'react';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../contexts/PurchaseOrderDetailsContext';

const PurchaseOrdersDetailsMainArea = () => {
  const { isLoading } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;

  const theme = useTheme();

  return !isLoading ? <Box sx={{
    border: '1px solid',
    borderColor: theme.palette.custom.gray[300],
  }} >
    <PurchaseOrdersDetailsFilters />
    <PurchaseOrdersDetailsTable />
  </Box>
    :
    <></>;
};

export default PurchaseOrdersDetailsMainArea;